import React, { FunctionComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect, RootStateOrAny } from 'react-redux'
import classNames from 'classnames'

import {
  changeMobileSidebarVisibility as changeMobileSidebarVisibilityAction,
  changeSidebarVisibility as changeSidebarVisibilityAction,
} from 'Redux/actions/sidebarActions'

import { SidebarProps } from 'Shared/types/reducerTypes'
import Sidebar from './Sidebar'
import Topbar from './Topbar'

type LayoutProps = {
  changeSidebarVisibility: () => void
  changeMobileSidebarVisibility: () => void
  sidebar: SidebarProps
  step: number
}

const Layout: FunctionComponent<LayoutProps> = ({
  changeSidebarVisibility,
  changeMobileSidebarVisibility,
  sidebar,
  step,
}) => {
  const layoutClass = classNames({
    layout: true,
    'layout--collapse': sidebar.collapse,
  })

  const onChangeSidebarVisibility = () => {
    changeSidebarVisibility()
  }

  const onChangeMobileSidebarVisibility = () => {
    changeMobileSidebarVisibility()
  }

  return (
    <div className={layoutClass}>
      <Topbar
        changeMobileSidebarVisibility={changeMobileSidebarVisibility}
        changeSidebarVisibility={onChangeSidebarVisibility}
        sidebar={sidebar}
        step={step}
      />
      <Sidebar
        changeMobileSidebarVisibility={onChangeMobileSidebarVisibility}
        // @ts-ignore
        changeSidebarVisibility={onChangeSidebarVisibility}
        sidebar={sidebar}
      />
    </div>
  )
}

const selector = (state: RootStateOrAny) => ({
  sidebar: state.sidebar,
  step: state.schedule.step,
})

const actions = {
  changeSidebarVisibility: changeSidebarVisibilityAction,
  changeMobileSidebarVisibility: changeMobileSidebarVisibilityAction,
}

export default withRouter(connect(selector, actions)(Layout))
